module.exports = __webpack_public_path__ + "assets/img/step2.fe14311e.jpg";